import React from "react";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Typography from "@mui/material/Typography";

export default function SimpleConfigTable({ columns, rows, onEdit, onLogicalDelete }) {
  const showEdit = typeof onEdit === "function";
  const showDelete = typeof onLogicalDelete === "function";

  return (
    <TableContainer className={"box-shadow"} component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="config table">
        <TableHead>
          <TableRow>
            <TableCell align="left" sx={{ color: "#B3B3B3", width: 20 }}>
              Sl.No
            </TableCell>
            {columns.map((c) => (
              <TableCell key={c.key} align="left" sx={{ color: "#B3B3B3" }}>
                {c.label}
              </TableCell>
            ))}
            {(showEdit || showDelete) && <TableCell colSpan={(showEdit ? 1 : 0) + (showDelete ? 1 : 0)} align="right" />}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.length > 0 ? (
            rows.map((r, idx) => (
              <TableRow hover key={r.id || idx}>
                <TableCell>{idx + 1}</TableCell>
                {columns.map((c) => (
                  <TableCell key={`${r.id}_${c.key}`} sx={{ color: "#3D3D3D" }}>
                    {r?.[c.key] ?? "-"}
                  </TableCell>
                ))}
                {showEdit && (
                  <TableCell align="right">
                    <Tooltip title={"Edit"}>
                      <IconButton
                        onClick={() => onEdit?.(r)}
                        sx={{ bgcolor: "#fff", boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;" }}
                      >
                        <DriveFileRenameOutlineIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                )}
                {showDelete && (
                  <TableCell align="right">
                    <Tooltip title={"Make inactive"}>
                      <IconButton onClick={() => onLogicalDelete?.(r.id)}>
                        <DeleteForeverIcon sx={{ color: "red" }} />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                )}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length + 1 + (showEdit ? 1 : 0) + (showDelete ? 1 : 0)} style={{ textAlign: "center" }}>
                <Typography style={{ color: "red" }}>No records</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
